import { Skeleton, Stack } from '@mui/material';

import { StyledDTicketPageLayoutFooter } from '@mopla/ui';

export const ManageBillingAddressFormSkeleton = () => {
	return (
		<>
			<Stack gap={1.5}>
				<Skeleton variant="rounded" width="60%" height={28} animation="pulse" />
				<Stack gap={2}>
					<Skeleton
						variant="rounded"
						width="100%"
						height={48}
						animation="pulse"
					/>
					<Skeleton
						variant="rounded"
						width="100%"
						height={48}
						animation="pulse"
					/>
					<Skeleton
						variant="rounded"
						width="100%"
						height={48}
						animation="pulse"
					/>
					<Stack direction="row" gap={1}>
						<Skeleton
							variant="rounded"
							height={48}
							animation="pulse"
							sx={{ flex: 1 }}
						/>
						<Skeleton
							variant="rounded"
							width={96}
							height={48}
							animation="pulse"
							sx={{ flexShrink: 0 }}
						/>
					</Stack>
					<Stack direction="row" gap={1}>
						<Skeleton
							variant="rounded"
							width={96}
							height={48}
							animation="pulse"
							sx={{ flexShrink: 0 }}
						/>
						<Skeleton
							variant="rounded"
							height={48}
							animation="pulse"
							sx={{ flex: 1 }}
						/>
					</Stack>
				</Stack>
			</Stack>
			<StyledDTicketPageLayoutFooter>
				<Skeleton
					variant="rounded"
					width="100%"
					height={48}
					animation="pulse"
				/>
			</StyledDTicketPageLayoutFooter>
		</>
	);
};
